<template>
  <div class="player">
    <div class="temPlayer">
      <div id="player">
        <watermark v-if="isShowWaterMark && isPlay" :isFullScreen="isRotateFullScreen" parentNodeName="player"
          ref="waterMark"></watermark>
      </div>
      <div class="tips" v-if="boolNextTip" :class="isRotateFullScreen ? 'fullScreen' : ''">
        即将播放{{ nextVideoTitle }}
      </div>
      <form action="javascript:;" class="input-danmu" v-show="isShowDanmuInput">
        <input type="text" v-model="sendDanmuVal" @keydown.enter="handleSendDanmu" @focus="handleDanmuFocus"
          @blur="handleDanmuBlur" placeholder="发个弹幕" class="danmu-txt">
        <img src="@/assets/images/course/video_icon_open@3x.png" v-if="checked" @click="handleChangeSwitch(false)" class="danmu-icon" alt="">
        <img src="@/assets/images/course/video_icon_close.png" v-else-if="!checked" @click="handleChangeSwitch(true)" class="danmu-icon" alt="">
      </form>
    </div>
  </div>
</template>

<script>
import Player from 'xgplayer'
import HlsJsPlayer from 'xgplayer-hls.js'
import Watermark from './WaterMark.vue'
import { handleTraceVideo, handleTraceVideoAsync } from '@/utils/trace.js'
import { traceVideoDuration } from '@/api/trace.js'
import { getBarrage, sendBarrage } from '@/api/api'
import { Toast } from 'vant'
import { hadnleUpdateVideo } from './common'
import Vue from 'vue'
import {ACCESS_TOKEN} from '../../../store/mutation-types'
export default {
  name: 'VideoPlayer',
  props: {
    // 视频源
    playerVideo: {
      type: Object,
      required: true
    },
    // 是否显示水印
    isShowWaterMark: {
      type: Boolean,
      default: false
    },
    // 课程列表
    videoList: {
      type: Array,
      required: true
    }
  },
  components: {
    Watermark
  },
  data () {
    return {
      // 是否已经rotate全屏
      isRotateFullScreen: false,
      nextVideoTitle: '',
      // 是否展示播放下一集
      boolNextTip: false,
      // 观看当前时长
      currentTime: 0,
      videoOptions: {
        id: 'player',
        url: '',
        width: '100%',
        height: '100%',
        playsinline: true,
        rotateFullscreen: true,
        'x5-video-player-type': '',
        playsInline: !this.isXFive,
        poster: '',
        lastPlayTime: 0,
        lastPlayTimeHideDelay: 3, // 提示文字展示时长（单位：秒）
        closeVideoClick: true,
        closeVideoTouch: true,
        errorTips: '播放失败',
        debug: {
          host: '192.168.124.7',
          port: 8080
        },
        disableProgress: true,

      },
      playDurationArr: [],
      playDuration: 0,
      curPlayVideoItem: {},
      isShowDanmuInput: false,
      danmuInputFocus: false,
      sendDanmuVal: '',
      checked: true
    }
  },
  computed: {
    isXFive () {
      let ua = navigator.userAgent.toLocaleLowerCase()
      return ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null
    },
    isIOSMobile () {
      // 平台、设备和操作系统
      let system = {
        win: false,
        mac: false,
        x11: false,
        ipad: false
      }
      // 检测平台
      let p = window.navigator.platform
      system.win = p.indexOf('Win') === 0
      system.mac = p.indexOf('Mac') === 0
      system.x11 =
        p === 'X11' || p.indexOf('Linux') === 0 || p.indexOf('Andriod') === 0
      system.ipad = navigator.userAgent.match(/iPad/i) != null
      if (system.win || system.mac || system.x11) {
        return false
      } else {
        var ua = navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) === 'micromessenger') {
          return true
        } else {
          return true
        }
      }
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
  },
  watch: {
    playerVideo (newVal, oldVal) {
      // 每一个视频都重绘一次，可以保证不同源视频可以正常判断
      if (newVal.notPlay) return
      newVal.duration = 0
      oldVal.duration = 0
      this.playerVideo = newVal
      this.prePlayerVideo = oldVal
      this.playerVideo.journeyId = this.$route.query.journeyId
      this.destroy(this.prePlayerVideo)
      this.init(this.playerVideo)
    },
  },
  mounted () {
    this.init(this.playerVideo)
    window.addEventListener('unload', (e) => this.unloadHandler(e))
  },
  beforeDestroy () {
    this.removeFullScreenHandle()
    this.destroy(this.playerVideo)
    localStorage.removeItem('playbackRate')
    localStorage.removeItem('curPlayVideoId')
  },
  destroyed () {
    window.removeEventListener('unload', (e) => this.unloadHandler(e))
  },
  methods: {
    // 发送弹幕
    handleSendDanmu () {
      let params = {
        'courseId': this.$route.query.courseId,
        'courseSectionId': this.playerVideo.id,
        'barrageText': this.sendDanmuVal,
        'iepUserId': this.userInfo.id,
        'barrageTime': Math.ceil(this.currentTime)
      }
      sendBarrage(params).then(res => {
        this.$toast(res.data)
        this.player.danmu.sendComment({ // 发送弹幕
          duration: 10000,
          id: Math.random(0, 100000000) * 100000000,
          start: Math.ceil(this.currentTime) * 1000 + 2000,
          txt: this.sendDanmuVal,
          style: { // 弹幕自定义样式
            color: '#fff',
            fontSize: '16px',
          }
        })
        this.sendDanmuVal = ''
      })
    },
    // 弹幕input，点击准备输入
    handleDanmuFocus () {
      document.querySelector('.course-player').classList.add('xgplayer-controls-danmu')
      this.isShowDanmuInput = true
    },
    // 弹幕input，点击离开输入
    handleDanmuBlur () {
      setTimeout(() => {
        document.querySelector('.course-player').classList.remove('xgplayer-controls-danmu')
        this.isShowDanmuInput = false
      }, 1000)
    },
    // 是否开启弹幕
    handleChangeSwitch (e) {
      if (this.sendDanmuVal && this.checked) {
        this.handleSendDanmu()
        return
      }
      this.checked = e
      if (e) {
        this.player.danmu.start()
      } else {
        this.player.danmu.stop()
      }
    },
    // 页面刷新
    // async beforeunloadHandler (e) {
    //   await this.handleSync(this.playerVideo)
    // },
    // 页面关闭，关闭包括了刷新，
    async unloadHandler (e) {
      await this.handleSync(this.playerVideo)
    },
    addFullScreenHandle () {
      document.querySelector('body').setAttribute('style', 'overflow: hidden')
      window.addEventListener('touchmove', this.touchMove, false)
    },
    removeFullScreenHandle () {
      document.querySelector('body').setAttribute('style', 'overflow: auto')
      window.removeEventListener('touchmove', this.touchMove)
    },
    touchMove (e) {
      e.preventDefault()
    },

    async init (initPlayer) {
      let barrageData = await getBarrage({
        courseId: this.$route.query.courseId,
        courseSectionId: this.playerVideo.id
      })
      let barrageDataL = barrageData.data.map(res => {
        let items = {
          duration: 10000,
          id: res.id,
          start: res.barrageTime * 1000,
          txt: res.barrageText,
          style: { // 弹幕自定义样式
            color: '#fff',
            fontSize: '16px',
          },
        }
        return items
      })
      this.videoOptions.danmu = {
        comments: barrageDataL.length > 0 ? barrageDataL : [],
        area: { // 弹幕显示区域
          start: 0, // 区域顶部到播放器顶部所占播放器高度的比例
          end: 1 // 区域底部到播放器顶部所占播放器高度的比例
        },
        closeDefaultBtn: true, // 开启此项后不使用默认提供的弹幕开关，默认使用西瓜播放器提供的开关
        defaultOff: true // 开启此项后弹幕不会初始化，默认初始化弹幕
      }
      this.$parent.$parent.currentVideo = initPlayer
      this.isRotateFullScreen = false
      this.boolNextTip = false
      // 当前播放的视频
      const $this = this
      // 添加默认loading,增加操作感
      Toast.loading({
        // 展现时长(ms)，值为 0 时，toast 不会消失
        duration: 10
      })
      // 这里判断当前视频类型
      const videoType = initPlayer.videoMaterial.url.substring(
        initPlayer.videoMaterial.url.lastIndexOf('.') + 1
      )
      // 这里判断是否全屏，默认支持全屏
      this.videoOptions.rotateFullscreen = true
      // 这里判断视频是否可以倍速播放
      if (initPlayer.videoSpeedPlayback === '1') {
        this.videoOptions.playbackRate = [0.5, 0.75, 1, 1.5, 2]
      }
      // 这里判断当前视频是否可以拖拽
      if (initPlayer.dragFlag === '1' || initPlayer.learningStatus === '1') {
        this.videoOptions.disableProgress = false
      }
      // 设置当前视频从第几秒开始,作用于播放记录
      const videoHistory = window.localStorage.getItem('videoHistory')
      this.videoOptions.lastPlayTime = videoHistory ? JSON.parse(videoHistory)[initPlayer.id] : 0
      // 视频poster
      this.videoOptions.poster = initPlayer.poster
      // 视频路劲
      this.videoOptions.url = initPlayer.videoMaterial.url
      if (videoType === 'm3u8') {
        this.player = new HlsJsPlayer(this.videoOptions)
      } else {
        this.player = new Player(this.videoOptions)
        // console.log(this.player, '有了')
      }
      this.player.on('play', function () {
        // 监听开始的时候
        // 判断如果有当前正在播放的内容，替换掉传入的
        initPlayer = Object.keys($this.curPlayVideoItem).length > 1 ? $this.curPlayVideoItem : initPlayer
        $this.player.danmu.start()
        if (localStorage.getItem('playbackRate')) {
          $this.player.video.playbackRate = localStorage.getItem('playbackRate')
        }
        // 默认开始播放的时候提交状态为2
        hadnleUpdateVideo(initPlayer)
      })
      // 监听视频倍速切换时记录下倍速
      this.player.on('ratechange', (e) => {
        if (!localStorage.getItem('curPlayVideoId') || localStorage.getItem('curPlayVideoId') === initPlayer.id) {
          localStorage.setItem('playbackRate', e.playbackRate)
          localStorage.setItem('curPlayVideoId', initPlayer.id)
        } else {
          localStorage.setItem('curPlayVideoId', initPlayer.id)
        }
      })
      // 获取当前视频的进度
      this.player.on('timeupdate', function (e) {
        let divs = document.querySelectorAll('.xgplayer-danmu div')
        if (divs.length > 0 && $this.isRotateFullScreen) {
          divs.forEach(node => {
            let leftTxt = (100 + Math.random(0, 1) * 10) + 'vh'
            let leftTxtX = (105 + Math.random(0, 1) * 10) + 'vh'
            let top = (Math.random(0, 1) * 92) + 'vw'
            if (!node.getAttribute('attrSet')) {
              node.style.transform = `translateX(-${leftTxtX}) translateY(0px) translateZ(0px)`
              node.style.left = `${leftTxt}`
              node.style.top = `${top}`
              node.setAttribute('attrSet', 'true')
            }
          })
        } else if (divs.length > 0 && !$this.isRotateFullScreen) {
          divs.forEach(node => {
            let leftTxt = (100 + Math.random(0, 1) * 10) + 'vw'
            let leftTxtX = (105 + Math.random(0, 1) * 10) + 'vw'
            let top = (Math.random(0, 1) * 190) + 'px'
            if (!node.getAttribute('attrSet')) {
              node.style.transform = `translateX(-${leftTxtX}) translateY(0px) translateZ(0px)`
              node.style.left = `${leftTxt}`
              node.style.top = `${top}`
              node.setAttribute('attrSet', 'true')
            }
          })
        }

        let videoBtmCon = document.querySelector('.xgplayer-mobile').className + ''
        if (videoBtmCon.indexOf('xgplayer-inactive') > -1) {
          $this.isShowDanmuInput = false
        } else {
          $this.isShowDanmuInput = true
        }
        // 记录当前播放的倍速
        $this.playbackRate = e.playbackRate
        // 判断如果有当前正在播放的内容，替换掉传入的
        initPlayer = Object.keys($this.curPlayVideoItem).length > 1 ? $this.curPlayVideoItem : initPlayer
        if (initPlayer.notPlay) {
          delete initPlayer.notPlay
        }
        $this.curVideoDuration = e.duration
        const currentTime = e ? e.currentTime : 0
        // 判断最后4秒提示跳到下一个视频，如果还有下一个视频
        if ($this.curVideoDuration - currentTime <= 10) {
          let curIndex = 0
          $this.videoList.map((item, index) => {
            if (item.id === initPlayer.id) {
              curIndex = index
            }
          })
          if (curIndex + 1 < $this.videoList.length) {
            let curVideo = $this.videoList[curIndex + 1]
            $this.nextVideoTitle = curVideo.title
            $this.boolNextTip = true
          }
        } else {
          $this.boolNextTip = false
        }
        // console.log(initPlayer, e.duration === currentTime, e.duration, currentTime, $this.boolNextTip, '是否自动进入下一个视频')
        if (e.duration === currentTime) {
          // 如果播放完，滞空当前播放的内容
          $this.curPlayVideoItem = {}
          if ($this.boolNextTip) {
            // 播放完成时自动播放下一个视频
            $this.playNextVideo(initPlayer)
            $this.nextPlayVideoCon = initPlayer
          }
          // 播放完成时要显示control工具
          e.root.children[1].style = 'display: flex'
          // 播放完成时上报信息
          $this.handlevideo(initPlayer)
          // 播放完成时记得更新状态
          // $this.$parent.hadnleUpdateStatus(initPlayer)
        } else {
          e.root.children[1].style = ''
        }
        $this.currentTime = currentTime
        $this.playDurationArr.push(currentTime)
        if ($this.playDurationArr.length > 1) {
          $this.handleStaticDuration()
          $this.$emit('timeupdate', { currentTime, playDuration: $this.playDuration, currentVideo: initPlayer })
        }
      })
      // 获取当前视频的进度
      this.player.on('currentTimeChange', function (e) {
        this.playDurationArr = []
      })
      this.player.on('pause', function () {
        // 监听暂停或者结束的时候
        // 判断如果有当前正在播放的内容，替换掉传入的
        initPlayer = Object.keys($this.curPlayVideoItem).length > 1 ? $this.curPlayVideoItem : initPlayer
        $this.handleStashVideoTime(initPlayer)
        $this.endTime = new Date() // 埋点观看结束时间
        $this.handleStaticDuration()
      })
      // 监听全屏变化
      this.player.on('getRotateFullscreen', (e) => {
        $this.isRotateFullScreen = true
      })
      // 监听全屏变化
      this.player.on('exitRotateFullscreen', (e) => {
        $this.isRotateFullScreen = false
      })
    },

    // 播放下一个视频
    playNextVideo (curplayer) {
      let curIndex = 0
      this.videoList.map((item, index) => {
        if (item.id === curplayer.id) {
          curIndex = index
        }
      })
      if (curIndex + 1 === this.videoList.length) return
      let curVideo = this.videoList[curIndex + 1]
      setTimeout(() => {
        // this.player.destroy()
        // this.init(curVideo)
        curVideo.notPlay = true
        this.curPlayVideoItem = curVideo
        // console.log(curVideo, '进来了')
        this.$parent.$parent.currentVideo = curVideo
        this.player.video.autoplay = true
        console.log(this.player, this.player.video, this.playbackRate, '23')
        this.player.src = curVideo.videoMaterial.url
      }, 20)
    },

    destroy (curplayer) {
      this.handlevideo(curplayer)
      this.player.destroy()
    },

    // 埋点方法
    handlevideo (curplayer) {
      if (curplayer) {
        this.prePlayerVideo = curplayer
      }
      // 监听销毁时的动作
      this.handleStashVideoTime(this.prePlayerVideo)
      this.handleStaticDuration()
      if (this.playDuration >= 1) {
        this.endTime = new Date() // 埋点观看结束时间
        this.prePlayerVideo.duration = Math.ceil(this.playDuration) // 页面停留时长，向上取整
        handleTraceVideo(this.prePlayerVideo)
        // 上报当前视频播放时长
        const params = {
          videoId: this.prePlayerVideo.id,
          iepUserId: this.userInfo.id,
          playDuration: Math.ceil(this.playDuration)
        }
        traceVideoDuration(params).then(() => { })
        this.playDuration = 0
      }
      this.currentTime = 0
    },

    // 页面关闭或者刷新的时候特意用fetch同步请求
    handleSync (curplayer) {
      if (curplayer) {
        this.prePlayerVideo = curplayer
      }
      const token = Vue.ls.get(ACCESS_TOKEN)
      const baseURL = process.env.baseURL
      // 监听销毁时的动作
      this.handleStashVideoTime(this.prePlayerVideo)
      this.handleStaticDuration()
      if (this.playDuration > 0) {
        this.endTime = new Date() // 埋点观看结束时间
        this.prePlayerVideo.duration = Math.ceil(this.playDuration) // 页面停留时长，向上取整
        // handleTraceVideo(this.prePlayerVideo)
        this.prePlayerVideo = Object.assign(this.prePlayerVideo, {
          token,
          baseURL
        })
        handleTraceVideoAsync(this.prePlayerVideo)
        // 上报当前视频播放时长
        const params = {
          videoId: this.prePlayerVideo.id,
          iepUserId: this.userInfo.id,
          playDuration: Math.ceil(this.playDuration)
        }
        fetch(`${baseURL}/api/course/completed/records/addPlayDuration/${params.videoId}`, {
          method: 'POST',
          body: JSON.stringify(params),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'userId': this.userInfo.id
          },
          keepalive: true
        })
        this.playDuration = 0
      }
      this.currentTime = 0
    },

    // 视频播放时长统计
    handleStaticDuration () {
      if (this.playDurationArr.length > 1) {
        this.playDurationArr[0] = (this.playDurationArr[1] - this.playDurationArr[0] > 1 || this.playDurationArr[0] > this.playDurationArr[1]) ? this.playDurationArr[1] : this.playDurationArr[0]
        this.playDuration = this.playDuration + Number(this.playDurationArr[this.playDurationArr.length - 1]) - Number(this.playDurationArr[0])
        this.playDurationArr = [this.playDurationArr[this.playDurationArr.length - 1]]
      }
    },
    // 缓存历史记录
    handleStashVideoTime (videoData) {
      if (!videoData) return
      if (window && window.localStorage && this.currentTime > 0) {
        let videoHistory = window.localStorage.getItem('videoHistory')
        if (this.curVideoDuration <= this.currentTime) {
          this.currentTime = 0
        }
        if (videoHistory) {
          videoHistory = Object.assign(JSON.parse(videoHistory), { [videoData.id]: this.currentTime })
        } else {
          videoHistory = { [videoData.id]: this.currentTime }
        }
        window.localStorage.setItem('videoHistory', JSON.stringify(videoHistory))
      }
    }
  }
}

</script>

<style lang="less" scoped>
.player,
.temPlayer {
  z-index: 100;
  width: 100%;
  height: 100%;
  clip: auto;
  position: relative;

  .tips {
    position: absolute;
    max-width: 100%;
    box-sizing: border-box;
    font-size: 12px;
    z-index: 999;
    bottom: 50px;
    padding: 10px;
    background-color: rgba(0, 0, 0, .3);
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &.fullScreen {
      -webkit-transform-origin: top left;
      -ms-transform-origin: top left;
      transform-origin: top left;
      -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: rotate(90deg);
      max-width: 100vh;
      height: 36px;
      bottom: 0;
      top: 0;
      left: 86px;
    }
  }

  .input-danmu {
    width: 80px;
    height: 24px;
    overflow: hidden;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 8px;
    z-index: 99;
    left: 130px;
    background-color: rgba(255, 255, 255, .3);
    border-radius: 80px;

    .danmu-txt {
      width: 70%;
      display: block;
      font-size: 12px;
      color: #333;
      font-weight: 400;
      outline: none;
      border: none;
      padding-left: 9px;
      box-sizing: border-box;
      line-height: 24px;
      background-color: transparent;

      &::placeholder {
        color: rgba(255, 255, 255, .5);
      }
    }
    .danmu-icon {
      width: 14px;
      padding-left: calc(15% - 7px);
      border-left: 1px solid #898989;
      height: 15px;
    }
  }

  .next {
    font-size: 24px;
    color: #fff;
    position: absolute;
    top: 70px;
    z-index: 999;
    left: 60%;
  }

  /deep/ .xgplayer-enter-spinner {
    width: 40px !important;
    height: 40px !important;
  }

  /deep/ .xgplayer-progress-played {
    background-image: #EB1700 !important;
  }

}
</style>
<style>
.xgplayer-controls-danmu .xgplayer-controls,
.xgplayer-controls-danmu .input-danmu {
  display: flex !important;
}

/* .xgplayer-danmu>* {
  left: 100vh !important;
  z-index: 9999;
} */
</style>



// WEBPACK FOOTER //
// src/views/course/components/VideoPlayer copy.vue